import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
@Component({
  selector: 'comment-item',
  templateUrl: './comment-item.component.html',
  styleUrls: ['./comment-item.component.scss'],
})
export class CommentItemComponent implements OnInit {
  @Input() comment: any;
  // @Input() case: any;
  
  constructor() {}

  get date() {
    return moment(this.comment.createdAt).format('d/MM/yyyy h:mm a	 HH:mm');
  }

  ngOnInit() {
    // console.log("case: ",this.case);
  }
}
